<template>
<div class="modal fade" id="modalOpenLogUser" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Log de saldo - Data {{dataUser.createdAt | formatDate}}</h4>
      </div>
      <div class="modal-body">
        <div class="portlet-body contate-table offset-top-20">
          <div class="table-scrollable table-scrollable-borderless">
            <table class="edit table table-hover table-light table-icon">
              <thead>
                <tr>
                  <th>Ação</th>
                  <th>Dia afetado</th>
                  <th>Saldo antes</th>
                  <th>Saldo depois</th>
                  <th>Acumulado</th>
                  <th>Feito por</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="c in dataUser.grouped">
                  <td>{{ c.balanceTimelineTypeStr }}</td>
                  <td>{{ c.pointReference | formatDate }}</td>
                  <td>{{ c.oldValue }}</td>
                  <td>{{ c.newValue }}</td>
                  <td>{{ c.totalBalanceInTicks }}</td>
                  <td>{{ c.createdByName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "modalOpenLogUser",
  props: ["dataCompanyModal"],
  data() {
    return {
      dataUser: {}
    };
  },
  watch: {
    dataCompanyModal: function (val) {
      console.log(val, "val");
      this.dataUser = val
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalOpenLogUser.vue